import { List, Record } from 'immutable'

export const DifferentActivityRecord = Record({
  activityId: null,
  day: null,
  name: null,
  description: null,
  proQuote: null,
  proQuoteAuthor: null,
  image: null,
  videoId: null,
  videoThumbnail: null,
  createdAt: null,
  updatedAt: null,
  levelId: null,
  levelName: null,
  proTrackName: null,
})

export class DifferentActivity extends DifferentActivityRecord {}

export const Loaded = Record({
  previous: false,
  upcoming: false,
})

export const DifferentActivities = Record({
  previous: List(),
  upcoming: List(),
  loaded: new Loaded(),
  pending: false,
})
